/** @jsx jsx */

import React, { useState, useEffect } from 'react';
import { keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';
import { values, colors } from 'styles/variables';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import Plus from 'assets/Plus.svg';

const { lPink } = colors;
const { headerHeight } = values;

const color = lPink;
// const width = 40;
const size = 40;
const bottomPadding = 30;
const getBoxShadow = hover =>
  `box-shadow: 0 3px 10px rgba(0, 0, 0, ${hover ? 0.25 : 0});`;

const fadeInHilite = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const Wrapper = ({ id, focusedNodeId }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      css={css`
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        padding: ${headerHeight + 3}px 3px ${bottomPadding}px 3px;
        pointer-events: none;
      `}
    >
      <div
        css={css`
          width: 100%;
          height: 100%;
          box-shadow: 0 0 0 1px
            ${focusedNodeId === id ? color : hover ? color : 'lightGrey'};
          transition: box-shadow 0.25s;
        `}
      />

      <div
        css={css`
          position: absolute;
          left: 50%;
          bottom: ${bottomPadding - size / 2}px;
          width: ${size}px;
          height: ${size}px;
          transform: translateX(-50%);
          // border: 1px solid ${color};
          border-radius: 50%;
          background: ${color} url('${Plus}') no-repeat;
        
          background-size: 40%;
          background-position: center;
          cursor: pointer;
          pointer-events: auto;

          transition: all 0.3s;

          ${getBoxShadow(false)}

          &:hover {
            ${getBoxShadow(true)}
          }
        
        `}
        onClick={() => {
          parent.setNewSectionWizard && parent.setNewSectionWizard(true);
        }}
      />

      <div
        css={css`
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          right: ${175 / 2}px;
          bottom: ${bottomPadding - size / 2}px;
          width: 175px;
          height: ${size}px;

          // border: 1px solid

          border-radius: 9999px;
          background: ${color};

          cursor: pointer;
          pointer-events: auto;

          color: #fff;
          font-size: 14px;
          transition: all 0.3s;

          ${getBoxShadow(false)}

          &:hover {
            ${getBoxShadow(true)}
          }
        `}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={() => {
          setCurrentBlock(focusedNodeId !== id ? { id } : null);
        }}
      >
        SETTINGS
      </div>
    </div>
  );
};

export default Wrapper;
